import React from "react";

const Field = (props) => {
  const { className, children } = props;
  return (
    <div className={className ? className + "_field" : "field"}>{children}</div>
  );
};

export default Field;
